/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import MachineDiagram from "../../../components/MachineDiagram.js";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    ol: "ol",
    li: "li"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, null, "使い方"), "\n", React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "APMA-2000 の電源を入れる。"), "\n", React.createElement(_components.li, null, "言語を選ぶ。"), "\n", React.createElement(_components.li, null, "ラジオ・チューナーのランプをドラッグするか、ダイアルを回して、ナラティヴや音楽のチャンネルをさがす。"), "\n", React.createElement(_components.li, null, "音声を聞きながら、この惑星における人間のあり方について、見つめなおす/深く思いをはせる/静かに考える。"), "\n", React.createElement(_components.li, null, "トラックをコントロールする。巻き戻し、早送り、一時停止などはここで。"), "\n", React.createElement(_components.li, null, "学びを助けるカードが印刷されます。クリックすると拡大します。"), "\n"), "\n", React.createElement(MachineDiagram));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
